import { produce } from 'immer';

const initialState = {
  adminData: undefined,
  isLoading: false,
};

const adminReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'FETCH_ADMIN_DATA':
      return produce(state, (draft) => {
        const { regionsData, storesData, usersData } = action.payload;
        draft.adminData = {
          regions: regionsData,
          stores: storesData,
          users: usersData,
        };
      });

    case 'ADD_REGION_DATA':
      return produce(state, (draft) => {
        const updatedStores = draft.adminData?.stores.map(
          (store) =>
            action.payload.regionData.Stores.find(
              (newStore) => newStore.id === store.id
            ) || store
        );

        const updatedUsers = draft.adminData?.users.map(
          (manager) =>
            action.payload.regionData.Managers.find(
              (newManager) => newManager.id === manager.id
            ) || manager
        );

        draft.adminData.regions[action.payload.regionData.id] =
          action.payload.regionData;
        draft.adminData.stores = updatedStores || [];
        draft.adminData.users = updatedUsers || [];
      });

    case 'ADD_STORE_DATA':
      return produce(state, (draft) => {
        const { storeData } = action.payload;

        storeData.Region?.forEach((region) => {
          draft.adminData.regions[region.id].Stores.push({
            id: storeData.id,
            CRMStoreId: storeData.CRMStoreId,
            SLSiteCode: storeData.SLSiteCode,
            StoreName: storeData.StoreName,
            Latitude: storeData.Latitude,
            Longitude: storeData.Longitude,
            NearbyStores: storeData.NearbyStores,
          });
        });

        draft.adminData.stores.push(storeData);
      });

    case 'UPDATE_REGION':
      return produce(state, (draft) => {
        const { region, users, stores } = action.payload;

        const updatedStores = draft.adminData?.stores.map(
          (store) =>
            stores.find((newStore) => newStore.id === store.id) || store
        );

        const updatedUsers = draft.adminData?.users.map(
          (manager) =>
            users.find((newManager) => newManager.id === manager.id) || manager
        );

        draft.adminData.regions[region.id] = region;
        draft.adminData.stores = updatedStores;
        draft.adminData.users = updatedUsers;
      });

    case 'UPDATE_STORE':
      return produce(state, (draft) => {
        const { editedRegions, ...store } = action.payload.store;

        const storeIndex = draft.adminData.stores.findIndex(
          (_store) => _store.id === store.id
        );
        if (storeIndex !== -1) draft.adminData.stores[storeIndex] = store;

        editedRegions.removed.forEach((region) => {
          draft.adminData.regions[region].Stores = draft.adminData.regions[
            region
          ].Stores.filter((_store) => _store.id !== store.id);
        });

        editedRegions.added.forEach((region) => {
          draft.adminData.regions[region].Stores.push({
            id: store.id,
            CRMStoreId: store.CRMStoreId,
            SLSiteCode: store.SLSiteCode,
            StoreName: store.StoreName,
            Latitude: store.Latitude,
            Longitude: store.Longitude,
            NearbyStores: store.NearbyStores,
          });
        });
      });

    case 'UPDATE_USER':
      return produce(state, (draft) => {
        const { editedRegions, ...user } = action.payload.user;

        const userIndex = draft.adminData.users.findIndex(
          (_user) => _user.id === user.id
        );

        if (userIndex !== -1) draft.adminData.users[userIndex] = user;

        editedRegions.removed.forEach((region) => {
          draft.adminData.regions[region].Managers = draft.adminData.regions[
            region
          ].Managers.filter((_manager) => _manager.id !== user.id);
        });

        editedRegions.added.forEach((region) => {
          draft.adminData.regions[region].Managers.push({
            id: user.id,
            UserName: user.UserName,
          });
        });
      });

    case 'DELETE_REGION':
      return produce(state, (draft) => {
        const { regionId, users } = action.payload;

        draft.adminData.users = draft.adminData?.users.map(
          (manager) =>
            users.find((newManager) => newManager.id === manager.id) || manager
        );

        delete draft.adminData.regions[regionId];
      });

    case 'DELETE_USER':
      return produce(state, (draft) => {
        const { id } = action.payload;

        draft.adminData.users = draft.adminData?.users.filter(
          (user) => user.id !== id
        );
      });

    case 'ADD_USER_DATA':
      return produce(state, (draft) => {
        draft.adminData.users = action.payload.users;
      });

    case 'ADMIN_IS_LOADING':
      return produce(state, (draft) => {
        draft.isLoading = true;
      });

    case 'ADMIN_IS_NOT_LOADING':
      return produce(state, (draft) => {
        draft.isLoading = false;
      });

    default:
      return state;
  }
};

export default adminReducer;
